import React from 'react'
import { useState, useEffect } from "react";
import InnerChat from './InnerChat';
import Home from './Home';
import QueryAnalytics from './QueryAnalytics';

import { Gear } from 'react-bootstrap-icons';

import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';

const AnalyticsContainer = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [initQuestion, setInitQuestion] = useState("");
  const [collapsed, setCollapsed] = useState(true);
  let navigate = useNavigate();
  
  const initialQuestion = (value) => {
    setInitQuestion(value);
  } 
  
  const RightScreen = () => {
    if (props.subPageName === "internalChat") {
      return <InnerChat authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} initQuestion={initQuestion} initialQuestion={initialQuestion} />
    }
    else if (props.subPageName === "home" && props.pageName === "analytics") {
      return <QueryAnalytics authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} />
    }
    else if (props.subPageName === "home") {
      return <Home authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} initialQuestion={initialQuestion} />
    }
    else if (props.subPageName === "analytics") {
      return <QueryAnalytics authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} />
    }
    else {
      return
    }
  }

  useEffect(() => {
    if (props.pageName === "analytics") {
      props.pageTypeHandler("Query Analytics");
    } else {
      props.pageTypeHandler("Internal AMA");
    }
  }, [props.pageName])
  
  useEffect(()=>{
    const uData = JSON.parse(localStorage.getItem("userData"));
    if(uData?.stripeData?.stripe_day_count === 0){
      navigate(`/404`);
    }
    if (uData?.data?.admin_ama != true) {
        navigate(`/Chat-Ai`);
    }
  },[])

  return (
    <>
      <div className='h-full'>
        {/* Static sidebar for desktop */}
        <Sidebar subPageName={props.subPageName} authToken={props.authToken} collapsed={collapsed} setCollapsed={setCollapsed}/>
        {/* Static sidebar for mobile */}
        <div className={`${collapsed ? 'lg:pl-16' : 'lg:pl-72'}`}>
          <div className="sm:hidden hidden sticky top-0 z-40 h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden" onClick={() => setSidebarOpen(true)}>
              <span className="sr-only">Open sidebar</span>
              <Gear className="h-6 w-6" aria-hidden="true" />
            </button>
            {/* Separator */}
          </div>
          <main className="pt-[5rem] pb-10 h-[100vh] bg-white border-l border-gray-200">
            <div className="px-6 sm:px-8 lg:px-10">
              <RightScreen pageName={props.pageName} subPageName={props.subPageName} authToken={ props.authToken } />
            </div>
          </main>
        </div>
      </div>
    </>
  )
}

export default AnalyticsContainer
